import userSettings from "@/components/mixins/user-settings"
import LocalListActionLine from "@/components/common/LocalListActionLine"
import exportCsv from "@/components/mixins/exportCsv"
import message from "@/components/mixins/message"
import popup from "@/components/mixins/popup"

export default {
    name: "LocalSortingMixin",
    components: {LocalListActionLine},
    mixins: [userSettings, exportCsv, message, popup],
    data() {
        return {
            sort: null,
            selectedEntities: [],
        }
    },
    beforeMount() {
        this.sort = this.getStoredSorting();
    },
    computed:{
        multipleActionOptions() {
            return [
                {value: 'choose', text: this.$gettext('Vyberte akci')},
                {value: 'exportCsv', text: this.$gettext('Exportovat do CSV')},
            ]
        },
    },
    methods: {
        getActiveSort(column) {
            return column === this.sort.column ? this.sort.direction : false;
        },
        changeSorting(data) {
            this.setUserSetting('sort', data);
            this.sort = data;
        },
        getStoredSorting() {
            return this.getSettingByKey('sort') ? this.getSettingByKey('sort') : this.getDefaultSorting();
        },
        getDefaultSorting() {
            return {column: 'sId', direction: 'asc' };
        },
        integerCompare(intA, intB) {
            if (intA < intB) { return -1 }
            else if (intA > intB) { return 1 }
            else { return 0 }
        },
        stringCompare(stringA, stringB) {
            if (stringA && stringB) {
                return stringA.localeCompare(stringB);
            } else {
                return null;
            }
        },
        toggleSelectAll(value) {
            let selected = []
            if (value) {
                this.entities.forEach(function (entity) {
                    selected.push(String(entity.id))
                }.bind(this))
            }
            this.selectedEntities = selected
        },
        select(e) {
            if (e.target.checked) {
                this.selectedEntities.push(String(e.target.value))
            } else {
                const index = this.selectedEntities.indexOf(String(e.target.value))
                if (index > -1) {
                    this.selectedEntities.splice(index, 1)
                }
            }
        },
        runMultipleAction(action, activeKey) {
            if (action === 'exportCsv'){
                this._exportCsv();
            }
            if (action === 'delete') {
                this.deleteEntity(this.selectedEntities.join())
            }
        },
        _exportCsv() {
            this._createExportCsv(this.csvHeaders, this.entities);
        },
        getCsvHeaderFromSortingTableTitle(sortingTableTitles){
            let header = {};
            for(const title of sortingTableTitles){
                if(title.hasOwnProperty("skipInCsv") && title.skipInCsv){
                    continue;
                }
                let columnName = title.column.split(/(?=[A-Z])/).join('_').toLowerCase();
                header[columnName] = {name: title.name};
            }

            return header;
        },

    },
}



// WEBPACK FOOTER //
// ./src/components/mixins/local-table.js